import { routes } from "@/routes/utils";
import { FileChartColumnIncreasing, Split } from "lucide-react";
import { useState } from "react";

const useCostAnalytics = () => {
  const [openCopyDistributionConfig, setOpenCopyDistributionConfig] = useState<boolean>(false);
    
  const costAnalyticsCards = [
    {
      id: "distribution-metrics-maintanance",
      title: "Create",
      desc: "Allocation Metrics Maintenance",
      icon: FileChartColumnIncreasing,
      link: `${routes.distributionMetricsMaintenance}`,
      subtitle: "",
      hideCount: true,
      apiKey: "draft",
    },
    {
      id: "distribution-rule-configuration",
      title: "Create",
      desc: "Allocation Rule Configuration",
      icon: Split,
      link: `${routes.distributionRuleConfiguration}`,
      subtitle: "",
      hideCount: true,
      apiKey: "draft",
    },
    {
      id: routes.copyDistributionConfiguration,
      title: "View",
      desc: "Copy Allocation Configuration",
      icon: FileChartColumnIncreasing,
      onClick: () => setOpenCopyDistributionConfig(true),
      subtitle: "",
      hideCount: true,
      apiKey: "",
    },
    {
      id: "traceability-report",
      title: "View",
      desc: "Traceability Report",
      icon: FileChartColumnIncreasing,
      link: `${routes.traceability}`,
      subtitle: "",
      hideCount: true,
      apiKey: "",
    },
    {
      id: routes.closeout,
      title: "View",
      desc: "Level Closeout Report",
      icon: FileChartColumnIncreasing,
      link: `${routes.closeout}`,
      subtitle: "",
      hideCount: true,
      apiKey: "",
    },
    {
      id: routes.costTrialBalance,
      title: "View",
      desc: "Cost Analytics Trial Balance",
      icon: FileChartColumnIncreasing,
      link: `${routes.costTrialBalance}`,
      subtitle: "",
      hideCount: true,
      apiKey: "",
    },
    {
      id: routes.managerialReport,
      title: "View",
      desc: "Managerial Reporting",
      icon: FileChartColumnIncreasing,
      link: `${routes.managerialReport}`,
      subtitle: "",
      hideCount: true,
      apiKey: "",
    },
  ];

  return {
    costAnalyticsCards,
    openCopyDistributionConfig,
    setOpenCopyDistributionConfig,
  };
};

export default useCostAnalytics;
